import { useCallback, useEffect, useState } from "react";
import { autoConnect, connect, detectChildWindow, disconnect } from "..";
import { defaultUserInfo, UserInfo } from "../type";

type useWhisperConnectProps = {
  refreshToken?: any;
  useAutoConnect?: boolean;
};

function useWhisperConnect({
  refreshToken,
  useAutoConnect,
}: useWhisperConnectProps) {
  const [userInfo, setUserInfo] = useState<UserInfo>(defaultUserInfo);
  const [isInWhisper, setIsInWhisper] = useState<boolean>(false);

  useEffect(() => {
    if (!Boolean(userInfo.new_address)) {
      autoConnect().then((res) => {
        setIsInWhisper(res.isInWhipser);
        if (res.userInfo && useAutoConnect) {
          setUserInfo(res.userInfo);
        }
      });
    }
  }, [userInfo, useAutoConnect]);

  const disconnectWhisper = useCallback(async () => {
    if (await disconnect()) {
      setUserInfo(defaultUserInfo);
    }
  }, []);

  let popupX = document.body.offsetWidth / 2 - 420 / 2;
  let popupY = window.screen.height / 2 - 500 / 2;
  const connectWhisper = useCallback(async () => {
    if (isInWhisper) {
      connect().then(setUserInfo);
    } else if (refreshToken) {
      alert("Easyswap only use in Whisper app")
      // const connectionWindow = window.open(
      //   `${process.env.REACT_APP_CONNECTION_URL}`,
      //   "EQBR_Connect_Module",
      //   `width=420px,height=500px, left=${popupX}, top=${popupY},resizable=no`
      // );
      // await detectChildWindow(connectionWindow, refreshToken);
    }
  }, [isInWhisper, refreshToken]);

  return {
    isConnect: Boolean(userInfo.new_address),
    userInfo,
    isInWhisper,
    connectWhisper,
    disconnectWhisper,
  };
}

export default useWhisperConnect;
